import { render, staticRenderFns } from "./similar-products-section.vue?vue&type=template&id=53ff46c5&"
import script from "./similar-products-section.vue?vue&type=script&lang=js&"
export * from "./similar-products-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports